import { fetchApi } from '../../../../lib/fetchApi';

export const deleteQuestion = async (id: number): Promise<void> => {
    await fetchApi.put(`/questions/delete/${id}`);    
};

